function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#twitter_svg__clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.977 17.219c7.168 0 11.09-5.94 11.09-11.09 0-.167-.004-.338-.011-.505A7.917 7.917 0 0019 3.606a7.686 7.686 0 01-2.237.613 3.92 3.92 0 001.714-2.156 7.836 7.836 0 01-2.475.946 3.903 3.903 0 00-6.645 3.554 11.071 11.071 0 01-8.033-4.07A3.902 3.902 0 002.53 7.695 3.903 3.903 0 01.764 7.21v.048a3.896 3.896 0 003.128 3.822 3.876 3.876 0 01-1.759.067 3.905 3.905 0 003.64 2.71A7.818 7.818 0 010 15.467a11.059 11.059 0 005.977 1.75z",
  fill: "#fff"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "twitter_svg__clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h19v19H0z"
})));

function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgTwitter;